import React, { useMemo, useState } from "react";
import * as Yup from "yup";

import { pushShippingMethod } from "lib/gtm";

import GTMPushFunnelStep from "components/gtmTag/pushFunnelStep";
import FunnelGrid from "../../components/FunnelGrid";
import FunnelShippingPlace from "./shippingOptions/FunnelShippingOptions";
import FunnelShippingCalendar from "./calendar/FunnelShippingCalendar";
import useCart from "hooks/useCart";
import FunnelForm from "../../components/FunnelForm/FunnelForm";
import { STEP_SHIPPING, STEP_CALENDAR, STEP_OPTIONS } from "../../constants";
import { getCartPrice } from "../../utils";
import { CartAddress, Shipping } from "types/cart";
import { RefurbishedProduct } from "types/refurbishedProduct";

const deliveryOptionSchema = Yup.object().shape({
  delivery_option_type: Yup.string().required("Merci de sélectionner un mode de livraison"),
});

const dateSelectionSchema = Yup.object().shape({
  date: Yup.string().required("Merci de choisir un créneau horaire"),
  slot: Yup.string().required(),
  recoveryOldDevice: Yup.boolean(),
  slotObject: Yup.object().shape({
    shipping_provider_id: Yup.number().required(),
    time_span_beginning: Yup.string().required(),
    time_span_end: Yup.string().required(),
  }),
});
const FunnelShipping: React.FunctionComponent = () => {
  const [cart, dispatch] = useCart();
  const [step, setStep] = useState<string>(
    cart.shipping?.date && cart.delivery_option_type ? STEP_CALENDAR : STEP_OPTIONS
  );
  const gtmProducts = useMemo<RefurbishedProduct[]>(() => cart.selection.map((s) => s.product), [cart.selection]);
  const gtmAddress = useMemo<CartAddress>(() => cart.shipping?.address, [cart.shipping]);

  const handleSubmitAction = (values: Shipping) => {
    pushShippingMethod("4", values, getCartPrice(cart), gtmProducts);
    dispatch({ type: "updateShipping", shipping: { ...values } });
  };
  const goBackFromCalendar = () => {
    setStep(STEP_OPTIONS);
  };
  const onSubmitOptions = () => {
    if (cart.shipping?.delivery_option_type) {
      setStep(STEP_CALENDAR);
    }
  };

  return (
    <FunnelGrid hideRecap={false} initialCart={undefined}>
      <GTMPushFunnelStep step="4" products={gtmProducts} address={gtmAddress} />
      {step === STEP_OPTIONS && (
        <FunnelForm
          setSubmitFormik={undefined}
          goBack={undefined}
          onSubmit={onSubmitOptions}
          submitText="Continuer"
          step={STEP_SHIPPING}
          initialValues={{
            delivery_option_type: cart.shipping.delivery_option_type || "",
            delivery_option_id: cart.shipping.delivery_option_id || null,
            recoverOldDevice: cart.shipping.recoverOldDevice || false,
          }}
          submitAction={(values) => handleSubmitAction(values)}
          validationSchema={deliveryOptionSchema}
        >
          <FunnelShippingPlace />
        </FunnelForm>
      )}
      {step === STEP_CALENDAR && (
        <FunnelForm
          goBack={goBackFromCalendar}
          submitText="Continuer"
          step={STEP_SHIPPING}
          initialValues={{
            date: "",
            slot: "",
          }}
          submitAction={(values) => handleSubmitAction(values)}
          validationSchema={dateSelectionSchema}
          setSubmitFormik={undefined}
          onSubmit={undefined}
        >
          <FunnelShippingCalendar />
        </FunnelForm>
      )}
    </FunnelGrid>
  );
};

export default FunnelShipping;
